(() => {
  if (window.ppBundlesInitialized) return;
  window.ppBundlesInitialized = true;

  let purchaseQueue = Promise.resolve();
  const addPresetBundle = async (root, form) => {
    const plan = form.querySelector('[name="selling_plan"]');
    const subscribed = root.querySelector('[data-bundle-switch]')?.checked === true;
    const planId = subscribed ? Number(root.dataset.sellingPlan) : 0;
    // Loop can replace hidden form values on collection cards. The visible
    // purchase switch is the source of truth for this custom bundle flow.
    if (plan) {
      plan.value = planId ? String(planId) : '';
      plan.disabled = !planId;
    }
    await window.PurePatchBundlePurchase.add({
      productId: Number(root.dataset.bundleProduct),
      variantId: Number(root.dataset.bundleVariant),
      planId,
      expectedPrice: Number(planId ? root.dataset.subscriptionCents : root.dataset.oneTimeCents)
    });
    // Match the product pages: refresh Rebuy and open the drawer, and only
    // fall back to the cart page when the Smart Cart is unavailable.
    if (window.Rebuy?.Cart?.fetchShopifyCart && window.Rebuy?.SmartCart?.show) {
      window.Rebuy.Cart.fetchShopifyCart(() => window.Rebuy.SmartCart.show());
      return;
    }
    window.location.assign(window.routes?.cart_url || window.Shopify.routes.root + "cart");
  };

  const initializeBundleForm = (root) => {
    const form = root.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;
    form.addEventListener("submit", (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (form.dataset.bundleSubmitting === "true") return;
      form.dataset.bundleSubmitting = "true";
      const button = form.querySelector('[type="submit"]');
      const error = root.querySelector(".product-form__error-message-wrapper");
      const message = root.querySelector(".product-form__error-message");
      if (error) error.hidden = true;
      button.disabled = true;
      button.setAttribute("aria-busy", "true");
      purchaseQueue = purchaseQueue.then(() => addPresetBundle(root, form)).catch((failure) => {
        if (message) message.textContent = failure.message || "This bundle could not be added. Please try again.";
        if (error) error.hidden = false;
      }).finally(() => {
        form.dataset.bundleSubmitting = "false";
        button.disabled = false;
        button.removeAttribute("aria-busy");
      });
    }, true);
  };

  const initializePurchase = (root) => {
    if (root.dataset.bundleReady === "true") return;
    root.dataset.bundleReady = "true";
    window.PurePatchBundleMoney?.localize(root);
    initializeBundleForm(root);
    const toggle = root.querySelector("[data-bundle-switch]");
    const plan = root.querySelector("[data-bundle-plan]");
    if (!toggle || !plan) return;
    const update = () => {
      const subscribed = toggle.checked;
      const price = subscribed ? root.dataset.subscriptionPrice : root.dataset.oneTimePrice;
      const savings = subscribed ? root.dataset.subscriptionSavings : root.dataset.oneTimeSavings;
      root.querySelectorAll("[data-bundle-price]").forEach((item) => { item.textContent = price; });
      root.querySelectorAll("[data-bundle-cadence]").forEach((item) => {
        item.textContent = subscribed ? root.dataset.monthlySuffix : root.dataset.onceSuffix;
      });
      root.querySelectorAll("[data-bundle-savings]").forEach((item) => {
        item.textContent = savings || "";
        item.hidden = !savings;
      });
      const terms = root.querySelector("[data-bundle-terms]");
      if (terms) {
        terms.textContent = root.dataset.monthlyTerms;
        terms.hidden = !subscribed;
      }
      const modeLabel = root.querySelector("[data-bundle-mode-label]");
      if (modeLabel) modeLabel.textContent = subscribed ? root.dataset.subscribeLabel : root.dataset.onceLabel;
      const shipping = root.querySelector("[data-bundle-shipping]");
      if (shipping) {
        const selectedCents = Number(subscribed ? root.dataset.subscriptionCents : root.dataset.oneTimeCents);
        shipping.hidden = root.dataset.freeShippingMarket !== "true" || selectedCents < 7500;
      }
      const termsSeparator = root.querySelector("[data-bundle-terms-separator]");
      if (termsSeparator) termsSeparator.hidden = !subscribed || !shipping || shipping.hidden;
      const termsRow = root.querySelector("[data-bundle-terms-row]");
      if (termsRow) termsRow.hidden = !subscribed && (!shipping || shipping.hidden);
      plan.value = subscribed ? root.dataset.sellingPlan : "";
      plan.disabled = !subscribed;
      root.dataset.purchaseMode = subscribed ? "subscription" : "one-time";
    };
    // Every bundle card and PDP starts with Subscribe & save selected.
    toggle.checked = true;
    toggle.addEventListener("change", update);
    update();
  };

  const initializeRail = (root) => {
    if (root.dataset.bundleRailReady === "true") return;
    root.dataset.bundleRailReady = "true";
    const track = root.querySelector("[data-bundle-track]");
    const cards = Array.from(track?.querySelectorAll(".pp-bundle-card") || []);
    const previous = root.querySelector("[data-bundle-prev]");
    const next = root.querySelector("[data-bundle-next]");
    const dots = Array.from(root.querySelectorAll("[data-bundle-dot]"));
    const controls = root.querySelector("[data-bundle-controls]");
    const status = root.querySelector("[data-bundle-status]");
    if (!track || cards.length < 2) return;
    let active = 0;
    let frame = 0;
    const sync = () => {
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      const offsets = cards.map((card) => Math.min(max, card.offsetLeft - cards[0].offsetLeft));
      active = offsets.reduce((best, offset, index) => Math.abs(offset - track.scrollLeft) < Math.abs(offsets[best] - track.scrollLeft) ? index : best, 0);
      if (controls) controls.hidden = max < 2;
      if (previous) previous.disabled = track.scrollLeft < 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      dots.forEach((dot, index) => dot.setAttribute("aria-current", index === active ? "true" : "false"));
      if (status) status.textContent = (active + 1) + " / " + cards.length;
    };
    const move = (index) => {
      const card = cards[Math.max(0, Math.min(cards.length - 1, index))];
      track.scrollTo({
        left: card.offsetLeft - cards[0].offsetLeft,
        behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth"
      });
    };
    previous?.addEventListener("click", () => move(active - 1));
    next?.addEventListener("click", () => move(active + 1));
    dots.forEach((dot, index) => dot.addEventListener("click", () => move(index)));
    track.addEventListener("scroll", () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(sync);
    }, { passive: true });
    track.addEventListener("keydown", (event) => {
      if (event.target !== track) return;
      if (event.key === "ArrowRight" || event.key === "ArrowLeft") {
        event.preventDefault();
        move(active + (event.key === "ArrowRight" ? 1 : -1));
      }
    });
    new ResizeObserver(sync).observe(track);
    sync();
  };

  const initializeGallery = (root) => {
    if (root.dataset.bundleGalleryReady === "true") return;
    root.dataset.bundleGalleryReady = "true";
    const image = root.querySelector("[data-bundle-main-image]");
    const thumbs = Array.from(root.querySelectorAll("[data-bundle-thumbnail]"));
    if (!image || thumbs.length < 2) return;
    let selected = 0;
    const select = (index) => {
      selected = (index + thumbs.length) % thumbs.length;
      image.src = thumbs[selected].dataset.imageSource;
      image.alt = thumbs[selected].dataset.imageAlt;
      image.removeAttribute("srcset");
      thumbs.forEach((thumb, position) => thumb.setAttribute("aria-current", position === selected ? "true" : "false"));
    };
    thumbs.forEach((thumb, index) => thumb.addEventListener("click", () => select(index)));
    root.querySelector("[data-gallery-prev]")?.addEventListener("click", () => select(selected - 1));
    root.querySelector("[data-gallery-next]")?.addEventListener("click", () => select(selected + 1));
    let startX = 0;
    let startY = 0;
    const stage = root.querySelector(".pp-bundle-gallery__stage");
    stage?.addEventListener("touchstart", (event) => {
      startX = event.changedTouches[0].clientX;
      startY = event.changedTouches[0].clientY;
    }, { passive: true });
    stage?.addEventListener("touchend", (event) => {
      const dx = event.changedTouches[0].clientX - startX;
      const dy = event.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) select(selected + (dx < 0 ? 1 : -1));
    }, { passive: true });
  };

  const initialize = (scope = document) => {
    scope.querySelectorAll("[data-bundle-purchase]").forEach(initializePurchase);
    scope.querySelectorAll("[data-bundle-rail]").forEach(initializeRail);
    scope.querySelectorAll("[data-bundle-gallery]").forEach(initializeGallery);
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => initialize(), { once: true });
  else initialize();
  document.addEventListener("shopify:section:load", (event) => initialize(event.target));
  window.addEventListener("pageshow", () => initialize());
})();
